// Mock data for The Grazing Trust SCIO website

export const siteConfig = {
  name: "The Grazing Trust",
  tagline: "A Safe Haven for Horses in Need",
  description: "Nonprofit Association working to achieve full SCIO status, providing refuge, rehabilitation, and rehoming for equines across Scotland.",
  oscrRegNo: "[OSCR REG NO]",
  location: "Scotland, UK",
  email: "info@thegrazingtrust.com",
  phone: "",
  address: "[ADDRESS], Scotland",
  legalStatus: "Nonprofit Association working to achieve full SCIO status"
};

export const heroData = {
  headline: "A Safe Haven for Horses in Need",
  subheadline: "We provide refuge, rehabilitation, and lifelong care for equines across Scotland who can no longer be cared for by their owners.",
  primaryCta: "Donate Now",
  secondaryCta: "Get Help for a Horse",
  image: "https://images.unsplash.com/photo-1656238728485-ac9aca296131?w=1600&auto=format&fit=crop"
};

export const missionPoints = [
  {
    id: 1,
    title: "Safe Refuge",
    description: "Providing sanctuary for horses at risk of neglect, abandonment, or unnecessary destruction."
  },
  {
    id: 2,
    title: "Natural Living",
    description: "High-standard care based on natural-living philosophy with appropriate herd environments and ample space."
  },
  {
    id: 3,
    title: "Rehabilitation",
    description: "Restoring physical and mental health through veterinary treatment, handling, and specialist training."
  },
  {
    id: 4,
    title: "Secure Futures",
    description: "Thoroughly vetted rehoming programmes or permanent lifelong sanctuary care for every horse."
  }
];

export const whatWeDoItems = [
  {
    id: "sanctuary",
    title: "Sanctuary & Daily Care",
    description: "Our natural-living philosophy ensures horses live in appropriate herd environments with ample space to graze, rest, and simply be horses.",
    image: "https://images.unsplash.com/photo-1505494978186-6cde6324454b?w=800&auto=format&fit=crop",
    link: "/what-we-do/sanctuary"
  },
  {
    id: "rehabilitation",
    title: "Rehabilitation",
    description: "Comprehensive veterinary care, sensitive handling, and specialist training to restore physical and mental wellbeing.",
    image: "https://images.unsplash.com/photo-1590839823121-c253bf8d1e7d?w=800&auto=format&fit=crop",
    link: "/what-we-do/rehabilitation"
  },
  {
    id: "rehoming",
    title: "Rehoming & Loan Programme",
    description: "Carefully matched placements through our thorough vetting process for horses ready for a new chapter.",
    image: "https://images.unsplash.com/photo-1692024424434-27d10abba669?w=800&auto=format&fit=crop",
    link: "/what-we-do/rehoming"
  },
  {
    id: "lifelong",
    title: "Lifelong Sanctuary",
    description: "Permanent care and compassionate end-of-life support for horses not suitable for rehoming.",
    image: "https://images.unsplash.com/photo-1656241281956-982c1af244f0?w=800&auto=format&fit=crop",
    link: "/what-we-do/lifelong-sanctuary"
  }
];

export const getInvolvedOptions = [
  {
    id: "donate",
    title: "Donate",
    description: "Your generous donations directly support the care, feeding, and medical treatment of our horses.",
    icon: "Heart",
    link: "/get-involved/donate",
    cta: "Make a Donation"
  },
  {
    id: "volunteer",
    title: "Volunteer",
    description: "Join our team of dedicated volunteers helping with daily care, events, and administrative support.",
    icon: "Users",
    link: "/get-involved/volunteer",
    cta: "Become a Volunteer"
  },
  {
    id: "fundraise",
    title: "Fundraise",
    description: "Organise your own fundraising event or challenge to help support horses in need.",
    icon: "Sparkles",
    link: "/get-involved/fundraise",
    cta: "Start Fundraising"
  }
];

export const liverySchemeInfo = {
  title: "Livery Yard Membership Scheme",
  description: "Promoting high welfare standards across Scotland through regular inspections, public ratings, and an independent reporting mechanism.",
  features: [
    "Regular welfare inspections by qualified assessors",
    "Public ratings system for transparency",
    "Anonymous welfare concern reporting",
    "Support and guidance for yard owners",
    "Recognition for high-standard facilities"
  ]
};

export const faqItems = [
  {
    question: "How can I surrender a horse to The Grazing Trust?",
    answer: "We understand that circumstances change and sometimes owners can no longer care for their horses. Please complete our Intake Enquiry form, and our team will assess the situation and discuss options with you. We handle all enquiries with compassion and discretion."
  },
  {
    question: "Can I adopt or loan a horse from the sanctuary?",
    answer: "Yes, horses who are suitable for rehoming may be available for loan or adoption through our Rehoming & Loan Programme. All potential homes are thoroughly vetted to ensure the best match for both horse and new carer."
  },
  {
    question: "How are donations used?",
    answer: "Donations directly support the daily care of our horses including feed, bedding, veterinary treatment, farrier visits, and facility maintenance. We are committed to transparency and publish regular updates on how funds are used."
  },
  {
    question: "What is the Livery Yard Membership Scheme?",
    answer: "Our scheme promotes high welfare standards at livery yards across Scotland. Member yards receive regular inspections and are rated publicly, helping horse owners make informed choices about where to keep their horses."
  },
  {
    question: "How can I report a welfare concern?",
    answer: "You can report welfare concerns anonymously through our online reporting form. All reports are taken seriously and handled confidentially. For emergencies, please contact local authorities or the SSPCA directly."
  }
];

export const newsItems = [
  {
    id: 1,
    title: "Welcome to The Grazing Trust",
    excerpt: "We're excited to launch our new sanctuary and share our mission with the community.",
    date: "2025-08-01",
    image: "https://images.unsplash.com/photo-1694792651411-2412d8f235fb?w=600&auto=format&fit=crop",
    slug: "welcome-to-the-grazing-trust"
  },
  {
    id: 2,
    title: "Understanding Equine Welfare",
    excerpt: "Learn about the key indicators of good welfare and how to recognise when a horse needs help.",
    date: "2025-07-15",
    image: "https://images.unsplash.com/photo-1743787505796-9b2fdffba1a2?w=600&auto=format&fit=crop",
    slug: "understanding-equine-welfare"
  },
  {
    id: 3,
    title: "Livery Yard Scheme Launching Soon",
    excerpt: "Our new membership scheme for livery yards will help promote welfare standards across Scotland.",
    date: "2025-07-01",
    image: "https://images.unsplash.com/photo-1692024424472-e48b1d35a58e?w=600&auto=format&fit=crop",
    slug: "livery-yard-scheme-launching"
  }
];

export const navigationItems = [
  { label: "Home", href: "/" },
  { label: "About", href: "/about" },
  { 
    label: "What We Do", 
    href: "/what-we-do",
    children: [
      { label: "Sanctuary & Daily Care", href: "/what-we-do/sanctuary" },
      { label: "Rehabilitation", href: "/what-we-do/rehabilitation" },
      { label: "Rehoming & Loan", href: "/what-we-do/rehoming" },
      { label: "Lifelong Sanctuary", href: "/what-we-do/lifelong-sanctuary" }
    ]
  },
  { label: "Help a Horse", href: "/help-a-horse" },
  { label: "Livery Scheme", href: "/livery-scheme" },
  { label: "Education", href: "/education" },
  { label: "Get Involved", href: "/get-involved" },
  { label: "News", href: "/news" },
  { label: "Contact", href: "/contact" }
];

export const teamMembers = [
  {
    id: 1,
    name: "[Trustee Name]",
    role: "Trustee",
    bio: "[Bio placeholder]"
  },
  {
    id: 2,
    name: "[Trustee Name]",
    role: "Trustee",
    bio: "[Bio placeholder]"
  },
  {
    id: 3,
    name: "[Trustee Name]",
    role: "Trustee",
    bio: "[Bio placeholder]"
  }
];

export const educationResources = [
  {
    id: 1,
    title: "Responsible Horse Ownership",
    description: "A comprehensive guide to the responsibilities and considerations of owning a horse.",
    type: "Guide"
  },
  {
    id: 2,
    title: "Recognising Signs of Neglect",
    description: "Learn how to identify when a horse may be suffering from neglect or poor welfare.",
    type: "Guide"
  },
  {
    id: 3,
    title: "Planning for Your Horse's Future",
    description: "What to consider and how to plan ahead for changes in circumstances.",
    type: "Guide"
  },
  {
    id: 4,
    title: "The Five Freedoms",
    description: "Understanding the fundamental welfare needs of horses.",
    type: "Factsheet"
  }
];
